// extracted by mini-css-extract-plugin
export default {"form":"add-user-to-company_form__fEJPI","formRow":"add-user-to-company_formRow__LuoF8"};